import React from 'react'

function RotaryFloorDB() {
  return (
    <embed src="\pdfs\E1.3.2_DB-D-DN_Rotary_floor_twist_outlet_05.2015_kr.pdf" width="100%" height="2100px" />
)
}

export default RotaryFloorDB